<template>
  <v-alert
    v-if="showError"
    title="Error"
    variant="outlined"
    type="warning"
    prominent
    border="top"
  >
    {{ errorMessage }}
  </v-alert>
</template>

<script>
import router from "@/router";
import DataService from "../services/DataService";

export default {
  name: "HelloWorld",
  props: {
    st: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      id: "",
      name: "",
      errorMessage: "",
      showError: false
    };
  },
  mounted() {
    this.showError = false;
    this.errorMessage = '';

    if( this.st.length <= 5 || this.st.length >= 30 ){
      this.errorMessage = 'Invalid value provided for state -' + this.st;
      this.showError = true;
      return;
    }

    DataService.authorizeState( this.st )
        .then( ( ) => {
          router.push( { path: "/", replace: true } );
        } )
        .catch( ( err ) => {
          this.errorMessage = `A problem occurred during launching. ${err.message}`;
          this.showError = true;
        } );
  },
};
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.v-alert {
 margin: 5%;
}
</style>
